import React, { Fragment } from 'react'
import { InputWrapper } from '../../parts/input-wrapper/InputWrapper'
import { NavLink } from 'react-router-dom'
import { FieldModel } from '../../shared/model/field-model'
import styles from "./LoginFieldSet.module.scss";

export interface LoginFieldSetProps {
  pageName: string;
  emailState: FieldModel;
  onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onEmailBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  passwordState: FieldModel;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const LoginFieldSet = (props: LoginFieldSetProps) => {
  return (
    <Fragment>
      <InputWrapper
        pageName={props.pageName}
        name="email"
        caption="Email Address"
        fieldState={props.emailState}
        shouldDisplayRequired
        inputType="email"
        autoCompleteType="email"
        onInputChange={props.onEmailChange}
        onInputBlur={props.onEmailBlur}
      />
      <InputWrapper
        pageName={props.pageName}
        name="password"
        caption="Password"
        inputType="password"
        autoCompleteType="current-password"
        fieldState={props.passwordState}
        shouldDisplayRequired
        onInputChange={props.onPasswordChange}
        onInputBlur={props.onPasswordBlur}
      />
      <div className={styles.forgot_password_container}>
        <NavLink className={styles.forgot_password_link} to="/forgotpassword">
          Forgotten Password?
        </NavLink>
      </div>
    </Fragment>
  )
}
